import React from 'react';
import toast from 'react-hot-toast';
import {
  Box,
  Button,
  Card,
  CardContent,
  Stack,
  Typography
} from '@mui/material';

import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import { useParameterizedQuery } from 'react-fetching-library';
import { getClientABCDocument } from '../../../services/request';

export const PackingListCard = ({ orderData }) => {
  const { query, loading } = useParameterizedQuery(getClientABCDocument);
  const handleDownloadPackingList = async () => {
    let fileName = '';
    const seasonYear = orderData.season_name.split(' ').pop();
    if (orderData.period_display.includes('1')) {
      fileName = `abc_1_${seasonYear}`;
    } else {
      fileName = `abc_3_5_${seasonYear}`;
    }
    const { payload, error, loading } = await query(fileName);
    if (!error && !loading) {

      const url = window.URL.createObjectURL(payload);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = url;
      a.download = 'ABC.pdf';
      a.click();
      window.URL.revokeObjectURL(url);

    } else {
      toast.error('Nie udało się pobrać pliku');
    }
  };

  return (
    <Card
      sx={{
        borderRadius: 4,
        boxShadow: theme => theme.shadows[2]
      }}
    >
      <CardContent sx={{ p: 5 }}>
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          mb={4}
        >
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: 2,
              bgcolor: 'primary.lighter',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <FactCheckOutlinedIcon color="primary" />
          </Box>

          <Typography
            variant="h4"
            fontWeight={700}
          >
            Lista rzeczy do zabrania
          </Typography>
        </Stack>

        <Typography
          color="text.secondary"
          sx={{ mb: 4 }}
        >
          Lista zawiera wszystkie niezbędne rzeczy,
          które uczestnicy powinni zabrać na wyjazd.
        </Typography>

        <Button
          variant="contained"
          size="large"
          startIcon={<DownloadOutlinedIcon />}
          onClick={
            handleDownloadPackingList
          }
          disabled={loading}
        >
          Pobierz listę rzeczy
        </Button>
      </CardContent>
    </Card>
  );
};
